import { arrayOf, bool, number, object, shape, string } from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {
  closeProductReplacementModal,
  openProductReplacementModal,
  selectReplenishmentProductDetail,
  unselectReplenishmentProductDetail,
} from '../../modules/replenishment';
import NinetyDaysPanel from '../Panels/NinetyDaysPanel/NinetyDaysPanel';
import ShipWithBoxPanel from '../Panels/ShipWithBoxPanel/ShipWithBoxPanel';

const Subscriptions = ({
  isCustomizeOpen,
  goWithBoxSubscriptions,
  goWithBoxPriceTotal,
  ninetyDaysSubscriptions,
  ninetyDaysPriceTotal,
  sysdata,
  editCampaign,
  isRefillSubscription,
}) => {
  const hasNinetyDaysPanelItems = ninetyDaysSubscriptions.length > 0;

  return (
    <div
      id="subscriptions"
      data-testid="subscriptions-container"
      data-e2e="subscriptions-container"
    >
      {!isRefillSubscription && (
        <ShipWithBoxPanel
          subscriptions={goWithBoxSubscriptions}
          displayShopNowBtn={isCustomizeOpen || editCampaign?.userAccess}
          sysdata={sysdata}
          subTotal={goWithBoxPriceTotal}
          editCampaign={editCampaign}
        />
      )}
      {isCustomizeOpen ? (
        // Only display the "Shipping Every 3 Months"
        // if user has a subscription
        hasNinetyDaysPanelItems && (
          <NinetyDaysPanel
            subscriptions={ninetyDaysSubscriptions}
            sysdata={sysdata}
            displaySeparator={false}
            subTotal={ninetyDaysPriceTotal}
            editCampaign={editCampaign}
          />
        )
      ) : (
        // Display both sections when Customize is CLOSED
        <NinetyDaysPanel
          subscriptions={ninetyDaysSubscriptions}
          sysdata={sysdata}
          displaySeparator={false}
          subTotal={ninetyDaysPriceTotal}
          editCampaign={editCampaign}
        />
      )}
    </div>
  );
};

Subscriptions.propTypes = {
  isCustomizeOpen: bool.isRequired,
  goWithBoxSubscriptions: arrayOf(object).isRequired,
  ninetyDaysSubscriptions: arrayOf(object).isRequired,
  sysdata: shape({
    boxData: shape({
      customizations: arrayOf(
        shape({
          additionalItems: arrayOf(
            shape({
              quantity: number.isRequired,
              price: number.isRequired,
            }),
          ).isRequired,
          questionType: string.isRequired,
          additionalItemCost: number.isRequired,
        }),
      ).isRequired,
    }),
    userData: shape({}).isRequired,
    isMobile: bool.isRequired,
    isProspect: bool.isRequired,
  }).isRequired,
  goWithBoxPriceTotal: number.isRequired,
  ninetyDaysPriceTotal: number.isRequired,
  editCampaign: shape({}).isRequired,
  isRefillSubscription: bool.isRequired,
};

const mapStateToProps = (state) => ({
  editCampaign: state.campaigns.edit,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      selectProductDetail: selectReplenishmentProductDetail,
      unselectProductDetail: unselectReplenishmentProductDetail,
      openReplacementModal: openProductReplacementModal,
      closeReplacementModal: closeProductReplacementModal,
    },
    dispatch,
  );

export default connect(mapStateToProps, mapDispatchToProps)(Subscriptions);
